import { render, staticRenderFns } from "./CleaningTimetable.vue?vue&type=template&id=582a5dd6&"
import script from "./CleaningTimetable.vue?vue&type=script&lang=js&"
export * from "./CleaningTimetable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
